<template>
  <div v-if="showListUsers">
    <Comentario :data="usersList" :columns="columns">
      <td slot="adminActions" slot-scope="item" class="acciones">
        <b-button
          @click="eliminarComentario(item.item)"
          class="actions-btn remove"
          v-b-tooltip.hover.left
          title="Eliminar Comentario"
          ><i class="bx bx-trash"></i
        ></b-button>
        <!-- <Roles /> -->
      </td>
    </Comentario>
  </div>
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";
import { showAlert } from "../../../../components/tools/utils";
import Swal from "sweetalert2";
import Comentario from "../../../../components/tables/Comentario.vue";
export default {
  components: {
    Comentario,
  },
  data() {
    return {
      usersList: [],
      showListUsers: true,
    };
  },
  props: ["data", "columns", "getComentarios"],
  computed: {
    ...mapState("items", ["items"]),
    ...mapState("sesion", ["usuario", "relacionUS"]),
  },
  methods: {
    eliminarComentario: async  function (comentario){
      const token = localStorage.getItem("userToken");
      Swal.fire({
        title: "¿Está seguro de realizar esta acción?",
        text: "Esta acción es irreversible.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Confirmar",
      }).then(async (result) =>{
        if (result.isConfirmed) {
          try {
            await axios.delete(
              `${process.env.VUE_APP_RUTA_API}/comentarios/${comentario.id}/`,
              {
                headers: {
                  Authorization: `JWT ${token}`,
                },
              }
            );
            this.getComentarios();
            showAlert({
              icon: "success",
              text: "Comentario eliminado con éxito.",
              timerProgressBar: true,
              timer: 3000,
            });
          } catch (error) {
            console.log(error);
          }
          }
        }
      )
      
    }
    
  },
  watch: {
    data: function() {
      this.usersList = this.data;
      this.showListUsers = true;
    },
  },
};
</script>

<style scoped>
.actions-btn {
  border-radius: 50px;
  height: 25px;
  width: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
}
.add {
  background: #4f52ff;
  font-size: 22px;
}
.remove {
  background: #ff4f4f;
  font-size: 22px;
}
.edit {
  background: #24c6ab;
  font-size: 17px;
}
.actions-btn:hover {
  background: #052333;
}
.acciones {
  display: flex;
  justify-content: space-evenly;
}
.bx-trash {
  font-size: 17px;
}

@media screen and (max-width: 680px) {
  .actions-btn {
    /* width: 30px !important; */
    font-size: 15px !important;
  }
}
@media screen and (max-width: 320px) {
  .btn-secondary {
    width: 25px !important;
    font-size: 8px !important;
  }
}

@media screen and (max-width: 373px) {
  .actions-btn {
    /* width: 10px !important; */
    font-size: 10px !important;
  }
}
</style>
